import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { CheckBox, SelectBox, TextArea, TextBox, Validator } from 'devextreme-react';

import { useCreateContractorIndividualMutation } from 'bus/contractorIndividual/services/services';
import { ContractorIndividualItem } from 'bus/contractorIndividual/types';
import { useGetContractorObjectLocationsQuery } from 'bus/contractorObject/services';

type Props = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const initialForm = {
  id: 0,
  name: '',
  phone: '',
  email: '',
  fault: 0,
  comment: '',
  contractorType: 1,
  isProvider: false,
  isDeleted: false,
  locationType: 0,
};

const ContractorIndividualAddModal: FC<Props> = (props) => {
  const [createContractorIndividual, { isLoading }] = useCreateContractorIndividualMutation();
  const { data: contractorObjectLocations } = useGetContractorObjectLocationsQuery();

  let createCatalogGroupRef = useRef<any>(null);
  let validationGroupInfividual = useRef<any>(null);

  const [form, setForm] = useState<ContractorIndividualItem>({ ...initialForm });

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (validationGroupInfividual.current?.instance.validate().isValid) {
      await createContractorIndividual({ ...form });
      props.refresh();
      props.changeVisible(false);
    }
  };

  const onHidden = () => {
    setForm({ ...initialForm });
    validationGroupInfividual.current?.instance.reset();
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Физ. лицо"
        width={500}
        onHidden={onHidden}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={validationGroupInfividual}>
                <Form formData={form} ref={createCatalogGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Имя" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Заполните Имя"
                            mode="text"
                            value={form.name}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, name: e.event.currentTarget.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Имя" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={12}>
                        <AppFiledBox label="Телефон" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Телефон"
                            mode="text"
                            value={form.phone}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, phone: e }));
                            }}
                            mask="+7 (000) 000-00-00"
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Телефон" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={12}>
                        <AppFiledBox label="Email" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Email"
                            mode="email"
                            value={form.email}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, email: e.event.target.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={12}>
                        <AppFiledBox label="Местность" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите местность"
                            mode="text"
                            value={form.locationType}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, locationType: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={contractorObjectLocations}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле местность" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={12}>
                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Комментарий"
                            value={form.comment}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={6}>
                        <AppFiledBox label="" labelTop>
                          <CheckBox
                            value={form.isProvider}
                            text="Поставщик"
                            onValueChanged={(e) => setForm((prev) => ({ ...prev, isProvider: e.value }))}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
              </ValidationGroup>

              <ModalFooter
                useSubmitBehavior={false}
                handleSubmit={handleSubmit}
                hideModal={() => props.changeVisible(false)}
                disabledSubmit={isLoading}
              />
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ContractorIndividualAddModal;
